import { SearchResults } from "./types";
import { baseUrl } from "../../base-api";
import { handleSubModuleError } from "../../tools";
import { ApiResponse } from "../../tools/types";



export const apiGetSearchResults = async ({
    searchParam,
  }: {
    searchParam: string;
  }): Promise<ApiResponse<SearchResults[]>> => {
    try {
      const { data, status } = await baseUrl.get<SearchResults[]>(
        `loans/search?searchQuery=${searchParam}`
      );
      return { response: data, status, success: !!Object.keys(data).length };
    } catch (error) {
      return handleSubModuleError(error);
    }
  };